import { render } from "./CompleteRegister.vue?vue&type=template&id=26ea0132&ts=true"
import script from "./CompleteRegister.vue?vue&type=script&lang=ts"
export * from "./CompleteRegister.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__